/* MUI */
import { Checkbox } from '@mui/material';
import { Table } from '@tanstack/react-table';

/*  React  */
import React from 'react';

/**
 * SelectAllHeader component renders a checkbox that controls the selection state of all rows in a table
 *
 * @component
 * @param {Object} props - Component props
 * @param {Object} props.table - Table instance
 * @returns {JSX.Element} Checkbox component for selecting/deselecting all rows
 */

export const SelectAllHeaderCell = <TData,>({
    table
}: {
    table: Table<TData>;
}): JSX.Element => (
    <Checkbox
        checked={table.getIsAllRowsSelected()}
        indeterminate={table.getIsSomeRowsSelected()}
        onChange={table.getToggleAllRowsSelectedHandler()}
        sx={{
            '&.MuiCheckbox-root': { width: 'unset' },
            padding: 0
        }}
    />
);
